import React, { useState } from "react";
import { useValidationToast, validateFields } from "../../utils/validation";
import { locName } from "../../utils/helpers";
import { TODAY, LABEL } from "../../utils/format";

function CalendarModule({state,dispatch,t}){
  const {meetings,calAccounts,lang,maintenance}=state;
  const vt=useValidationToast();
  /* Scheduled maintenance items as calendar events */
  const maintEvents=(maintenance||[]).filter(m=>(m.status==="in_progress"||m.status==="approved"||m.status==="Scheduled")&&m.dueDate).map(m=>({id:m.id,title:`🔧 ${m.title}`,date:m.dueDate,time:"09:00",end:"10:00",location:locName(state.locations||[],m.locId),accountId:"__facility__",isMaintenance:true}));
  const [view,setView]=useState("month");
  const [selectedMeeting,setSelectedMeeting]=useState(null);
  const now=new Date();
  const [month,setMonth]=useState(now.getMonth());
  const [year,setYear]=useState(now.getFullYear());
  const [weekOffset,setWeekOffset]=useState(0);
  // Add calendar form
  const [showAddCal,setShowAddCal]=useState(false);
  const [calForm,setCalForm]=useState({name:"",color:"#2B5EA7"});
  // Add event form
  const [showAddEvent,setShowAddEvent]=useState(false);
  const [evForm,setEvForm]=useState({title:"",date:TODAY,time:"09:00",end:"10:00",location:"",accountId:""});

  const isRTL=lang==="ar";
  const addCalendar=()=>{
    const m=validateFields([{ok:calForm.name.trim(),label:isRTL?"الاسم":"Name"}]);
    if(m.length){vt.show(m.join(", "));return;}
    dispatch({type:"ADD_CAL_ACCOUNT",acc:{id:`ca${Date.now()}`,name:calForm.name.trim(),email:"",color:calForm.color,active:true}});
    setCalForm({name:"",color:"#2B5EA7"});setShowAddCal(false);
  };

  const addEvent=()=>{
    const m=validateFields([{ok:evForm.title.trim(),label:isRTL?"العنوان":"Title"},{ok:evForm.accountId,label:isRTL?"الحساب":"Account"}]);
    if(m.length){vt.show(m.join(", "));return;}
    dispatch({type:"ADD_MEETING",meeting:{id:`me${Date.now()}`,title:evForm.title.trim(),date:evForm.date,time:evForm.time,end:evForm.end,location:evForm.location,accountId:evForm.accountId}});
    setEvForm({title:"",date:TODAY,time:"09:00",end:"10:00",location:"",accountId:""});setShowAddEvent(false);
  };

  const getDaysInMonth=(m,y)=>new Date(y,m+1,0).getDate();
  const getFirstDayOfMonth=(m,y)=>new Date(y,m,1).getDay();
  const daysInMonth=getDaysInMonth(month,year);
  const firstDay=getFirstDayOfMonth(month,year);

  const activeMeetings=[...meetings.filter(m=>calAccounts.find(c=>c.id===m.accountId)?.active),...maintEvents];
  const todayMeetings=activeMeetings.filter(m=>m.date===TODAY).sort((a,b)=>a.time.localeCompare(b.time));

  const hasEvent=(day)=>{
    const d=`${year}-${String(month+1).padStart(2,"0")}-${String(day).padStart(2,"0")}`;
    return activeMeetings.some(m=>m.date===d);
  };

  // Weekly view helpers
  const getWeekDays=(offset)=>{
    const base=new Date(now);
    // Go to Monday of current week
    const day=base.getDay();
    const diff=base.getDate()-(day===0?6:day-1);
    base.setDate(diff+(offset*7));
    return Array.from({length:7},(_,i)=>{
      const d=new Date(base);
      d.setDate(base.getDate()+i);
      return d;
    });
  };
  const weekDays=getWeekDays(weekOffset);
  const fmtDate=(d)=>`${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,"0")}-${String(d.getDate()).padStart(2,"0")}`;
  const weekDayNames=isRTL
    ?["الاثنين","الثلاثاء","الأربعاء","الخميس","الجمعة","السبت","الأحد"]
    :["Mon","Tue","Wed","Thu","Fri","Sat","Sun"];
  const monthNames=isRTL
    ?["يناير","فبراير","مارس","أبريل","مايو","يونيو","يوليو","أغسطس","سبتمبر","أكتوبر","نوفمبر","ديسمبر"]
    :["January","February","March","April","May","June","July","August","September","October","November","December"];
  const dayNames=isRTL
    ?["أح","إث","ثل","أر","خم","جم","سب"]
    :["Su","Mo","Tu","We","Th","Fr","Sa"];
  const weekLabel=`${weekDays[0].getDate()} ${monthNames[weekDays[0].getMonth()]} – ${weekDays[6].getDate()} ${monthNames[weekDays[6].getMonth()]} ${weekDays[6].getFullYear()}`;

  return(
    <div className="page">
      {vt.Toast}
      <div className="ph">
        <div><div className="ptitle">{state.platformModuleNames?.Calendar||t.calendar}</div><div className="psub">{state.moduleSubtitles?.Calendar||t.unifiedCalendarSubtitle}</div></div>
        <div className="pacts">
          <button className={`btn btn-sm ${view==="day"?"btn-p":"btn-s"}`} onClick={()=>setView("day")}>{t.dayView}</button>
          <button className={`btn btn-sm ${view==="week"?"btn-p":"btn-s"}`} onClick={()=>setView("week")}>{t.weekView}</button>
          <button className={`btn btn-sm ${view==="month"?"btn-p":"btn-s"}`} onClick={()=>setView("month")}>{t.monthView}</button>
          {calAccounts.length>0&&<button className="btn btn-p btn-sm" onClick={()=>{setEvForm(f=>({...f,accountId:calAccounts.find(c=>c.active)?.id||calAccounts[0]?.id||""}));setShowAddEvent(true);}}>{t.addEvent}</button>}
        </div>
      </div>

      <div className="ga" style={{gap:18}}>
        <div>
          {view==="month"&&(
            <div className="card">
              <div className="ch">
                <button className="btn btn-g btn-sm" onClick={()=>{if(month===0){setMonth(11);setYear(y=>y-1);}else setMonth(m=>m-1);}}>←</button>
                <div className="ct" style={{flex:1,textAlign:"center"}}>{monthNames[month]} {year}</div>
                <button className="btn btn-g btn-sm" onClick={()=>{if(month===11){setMonth(0);setYear(y=>y+1);}else setMonth(m=>m+1);}}>→</button>
              </div>
              <div className="cal-full">
                <div className="cal-day-header">{dayNames.map(d=><div key={d} className="cal-day-lbl">{d}</div>)}</div>
                <div className="cal-grid">
                  {Array.from({length:firstDay}).map((_,i)=><div key={`e${i}`} className="cal-cell other-month"/>)}
                  {Array.from({length:daysInMonth}).map((_,i)=>{
                    const day=i+1;
                    const isToday=day===now.getDate()&&month===now.getMonth()&&year===now.getFullYear();
                    return <div key={day} className={`cal-cell ${isToday?"today":""} ${hasEvent(day)?"has-event":""}`}>{day}</div>;
                  })}
                </div>
              </div>
            </div>
          )}

          {view==="day"&&(
            <div className="card">
              <div className="ch"><div className="ct">{t.today} — {LABEL}</div><span className="pill p-blu">{todayMeetings.length} {t.meetingsLabel}</span></div>
              {todayMeetings.length===0&&<div className="empty">{t.noMeetings}</div>}
              {todayMeetings.map(m=>{
                const acc=calAccounts.find(c=>c.id===m.accountId);
                return(
                  <div key={m.id} className="cal-meeting" onClick={()=>setSelectedMeeting(m)}>
                    <div className="cal-time">{m.time}</div>
                    <div className="cal-dot" style={{background:acc?.color||"var(--g300)"}}/>
                    <div style={{flex:1}}>
                      <div className="cal-name">{m.title}</div>
                      <div className="cal-src">{m.time} – {m.end} · {m.location} · {acc?.name}</div>
                    </div>
                  </div>
                );
              })}
            </div>
          )}

          {view==="week"&&(
            <div className="card">
              <div className="ch">
                <button className="btn btn-g btn-sm" onClick={()=>setWeekOffset(o=>o-1)}>←</button>
                <div className="ct" style={{flex:1,textAlign:"center"}}>{weekLabel}</div>
                <button className="btn btn-g btn-sm" onClick={()=>setWeekOffset(o=>o+1)}>→</button>
                <button className="btn btn-g btn-xs" onClick={()=>setWeekOffset(0)} style={{marginInlineStart:6}}>{t.today}</button>
              </div>
              {/* Week grid — 7 columns, one per day */}
              <div style={{overflowX:"auto"}}>
                <div style={{display:"grid",gridTemplateColumns:"repeat(7,1fr)",borderBottom:"1px solid var(--g100)"}}>
                  {weekDays.map((d,i)=>{
                    const isToday=fmtDate(d)===TODAY;
                    return(
                      <div key={i} style={{padding:"8px 10px",borderRight:i<6?"1px solid var(--g100)":"none",background:isToday?"var(--g50)":"transparent",textAlign:"center"}}>
                        <div style={{fontSize:10,fontWeight:600,color:"var(--g400)",textTransform:"uppercase",letterSpacing:".08em",marginBottom:3}}>{weekDayNames[i]}</div>
                        <div style={{width:26,height:26,borderRadius:"50%",background:isToday?"var(--ink)":"transparent",color:isToday?"white":"var(--g600)",fontSize:13,fontWeight:isToday?600:400,display:"flex",alignItems:"center",justifyContent:"center",margin:"0 auto"}}>{d.getDate()}</div>
                      </div>
                    );
                  })}
                </div>
                <div style={{display:"grid",gridTemplateColumns:"repeat(7,1fr)",minHeight:200}}>
                  {weekDays.map((d,i)=>{
                    const dateStr=fmtDate(d);
                    const dayMeetings=activeMeetings.filter(m=>m.date===dateStr).sort((a,b)=>a.time.localeCompare(b.time));
                    const isToday=dateStr===TODAY;
                    return(
                      <div key={i} style={{borderRight:i<6?"1px solid var(--g100)":"none",background:isToday?"rgba(26,23,20,0.01)":"transparent",padding:"6px 4px",minHeight:120}}>
                        {dayMeetings.map(m=>{
                          const acc=calAccounts.find(c=>c.id===m.accountId);
                          return(
                            <div key={m.id} onClick={()=>setSelectedMeeting(m)} style={{background:acc?.color?`${acc.color}18`:"var(--g50)",border:`1px solid ${acc?.color?acc.color+"44":"var(--g200)"}`,borderRadius:"var(--r)",padding:"4px 7px",marginBottom:4,cursor:"pointer",transition:"opacity .08s"}}
                              onMouseEnter={e=>e.currentTarget.style.opacity=".8"} onMouseLeave={e=>e.currentTarget.style.opacity="1"}>
                              <div style={{fontSize:11,fontWeight:600,color:"var(--ink)",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{m.title}</div>
                              <div style={{fontSize:10,color:"var(--g500)",fontFamily:"var(--fm)"}}>{m.time}</div>
                            </div>
                          );
                        })}
                        {!dayMeetings.length&&<div style={{fontSize:11,color:"var(--g300)",textAlign:"center",marginTop:16}}>—</div>}
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          )}
        </div>

        <div style={{display:"flex",flexDirection:"column",gap:14}}>
          {/* ACCOUNTS */}
          <div className="card">
            <div className="ch"><div className="ct">{t.calendars}</div><button className="btn btn-s btn-sm" onClick={()=>setShowAddCal(true)}>+ {t.add}</button></div>
            {calAccounts.length===0&&<div className="empty" style={{padding:"14px 18px",fontSize:13}}>{t.noCalendarsYet}</div>}
            <div className="cb">
              {calAccounts.map(acc=>(
                <div key={acc.id} className={`cal-account ${acc.active?"":"off"}`}>
                  <div className="cal-account-dot" style={{background:acc.active?acc.color:"var(--g300)",cursor:"pointer"}} onClick={()=>dispatch({type:"TOGGLE_CAL",id:acc.id})}/>
                  <div style={{flex:1,cursor:"pointer"}} onClick={()=>dispatch({type:"TOGGLE_CAL",id:acc.id})}>
                    <div style={{fontSize:13,fontWeight:500,color:acc.active?"var(--ink)":"var(--g400)"}}>{acc.name}</div>
                    {acc.email&&<div style={{fontSize:11,color:"var(--g400)"}}>{acc.email}</div>}
                  </div>
                  <div className={`toggle ${acc.active?"on":""}`} onClick={()=>dispatch({type:"TOGGLE_CAL",id:acc.id})} style={{cursor:"pointer"}}/>
                  <button className="btn btn-d btn-sm" style={{marginInlineStart:6,fontSize:10,padding:"1px 7px"}} onClick={()=>dispatch({type:"REMOVE_CAL_ACCOUNT",id:acc.id})}>✕</button>
                </div>
              ))}
            </div>
            {/* Add calendar inline form */}
            {showAddCal&&(
              <div style={{borderTop:"1px solid var(--g100)",padding:"12px 18px",display:"flex",flexDirection:"column",gap:10}}>
                <div style={{fontSize:11,fontWeight:600,color:"var(--g400)",textTransform:"uppercase",letterSpacing:".08em"}}>{t.newCalendar}</div>
                <input className="fi" value={calForm.name} onChange={e=>setCalForm(f=>({...f,name:e.target.value}))} placeholder={t.calendarName} autoFocus onKeyDown={e=>e.key==="Enter"&&addCalendar()}/>
                <div style={{display:"flex",alignItems:"center",gap:8}}>
                  <label style={{fontSize:12,color:"var(--g500)"}}>{t.color}</label>
                  {["#2B5EA7","#C9A84C","#2D7D52","#D94F3D","#8B5CF6","#0078D4","#555"].map(c=>(
                    <div key={c} onClick={()=>setCalForm(f=>({...f,color:c}))} style={{width:18,height:18,borderRadius:"50%",background:c,cursor:"pointer",border:`2px solid ${calForm.color===c?"var(--ink)":"transparent"}`,flexShrink:0}}/>
                  ))}
                </div>
                <div style={{display:"flex",gap:8}}>
                  <button className="btn btn-p btn-sm" onClick={addCalendar}>{t.addCalendar}</button>
                  <button className="btn btn-g btn-sm" onClick={()=>setShowAddCal(false)}>{t.cancel}</button>
                </div>
              </div>
            )}
          </div>

          {/* TODAY QUICK */}
          <div className="card">
            <div className="ch"><div className="ct">{t.todayAtGlance}</div></div>
            {todayMeetings.slice(0,5).map(m=>{
              const acc=calAccounts.find(c=>c.id===m.accountId);
              return(
                <div key={m.id} style={{display:"flex",alignItems:"center",gap:10,padding:"8px 18px",borderBottom:"1px solid var(--g100)"}}>
                  <div style={{fontFamily:"var(--fm)",fontSize:11,color:"var(--g400)",minWidth:40,fontWeight:500}}>{m.time}</div>
                  <div style={{width:6,height:6,borderRadius:"50%",background:acc?.color||"var(--g300)",flexShrink:0}}/>
                  <div style={{flex:1,fontSize:13,fontWeight:500,letterSpacing:"-.01em"}}>{m.title}</div>
                </div>
              );
            })}
            {!todayMeetings.length&&<div className="empty" style={{padding:"16px"}}>{t.noMeetings}</div>}
          </div>
        </div>
      </div>

      {/* Event detail modal */}
      {selectedMeeting&&(
        <div className="mo" onClick={()=>setSelectedMeeting(null)}>
          <div className="md" style={{maxWidth:400}} onClick={e=>e.stopPropagation()}>
            <div className="mh"><div className="mt">{selectedMeeting.title}</div><button className="btn btn-g btn-sm" onClick={()=>setSelectedMeeting(null)}>✕</button></div>
            <div className="mb">
              <div style={{display:"flex",flexDirection:"column",gap:10}}>
                {[[t.time,`${selectedMeeting.time} – ${selectedMeeting.end}`],[t.date,selectedMeeting.date],[t.location,selectedMeeting.location||"—"],[t.calendar,calAccounts.find(c=>c.id===selectedMeeting.accountId)?.name||"—"]].map(([k,v])=>(
                  <div key={k} style={{display:"flex",gap:12}}>
                    <div style={{fontSize:12,fontWeight:600,color:"var(--g400)",minWidth:72,textTransform:"uppercase",letterSpacing:".06em",paddingTop:2}}>{k}</div>
                    <div style={{fontSize:14,color:"var(--ink)",fontWeight:500}}>{v}</div>
                  </div>
                ))}
              </div>
            </div>
            <div className="mf"><button className="btn btn-d btn-sm" onClick={()=>{dispatch({type:"REMOVE_MEETING",id:selectedMeeting.id});setSelectedMeeting(null);}}>{t.delete}</button><button className="btn btn-g" onClick={()=>setSelectedMeeting(null)}>{t.close}</button></div>
          </div>
        </div>
      )}

      {/* Add event modal */}
      {showAddEvent&&(
        <div className="mo" onClick={()=>setShowAddEvent(false)}>
          <div className="md" style={{maxWidth:440}} onClick={e=>e.stopPropagation()}>
            <div className="mh"><div className="mt">{t.newEvent}</div><button className="btn btn-g btn-sm" onClick={()=>setShowAddEvent(false)}>✕</button></div>
            <div className="mb">
              <div className="fg" style={{marginBottom:12}}><label className="fl">{t.title}</label><input className="fi" value={evForm.title} onChange={e=>setEvForm(f=>({...f,title:e.target.value}))} autoFocus/></div>
              <div className="fr">
                <div className="fg"><label className="fl">{t.date}</label><input className="fi" type="date" value={evForm.date} onChange={e=>setEvForm(f=>({...f,date:e.target.value}))}/></div>
                <div className="fg"><label className="fl">{t.startTime}</label><input className="fi" type="time" value={evForm.time} onChange={e=>setEvForm(f=>({...f,time:e.target.value}))}/></div>
                <div className="fg"><label className="fl">{t.endTime}</label><input className="fi" type="time" value={evForm.end} onChange={e=>setEvForm(f=>({...f,end:e.target.value}))}/></div>
              </div>
              <div className="fg"><label className="fl">{t.location}</label><input className="fi" value={evForm.location} onChange={e=>setEvForm(f=>({...f,location:e.target.value}))}/></div>
              <div className="fg"><label className="fl">{t.calendar}</label>
                <select className="fs" value={evForm.accountId} onChange={e=>setEvForm(f=>({...f,accountId:e.target.value}))}>
                  <option value="">{t.selectCalendar}</option>
                  {calAccounts.filter(c=>c.active).map(c=><option key={c.id} value={c.id}>{c.name}</option>)}
                </select>
              </div>
            </div>
            <div className="mf"><button className="btn btn-g" onClick={()=>setShowAddEvent(false)}>{t.cancel}</button><button className="btn btn-p" onClick={addEvent} disabled={!evForm.title.trim()||!evForm.accountId}>{t.addEventBtn}</button></div>
          </div>
        </div>
      )}
    </div>
  );
}

export default CalendarModule;
